export default {"src":"/_next/static/media/MNST.7655bffd.svg","height":18,"width":18};